import { render, staticRenderFns } from "./StandartReport.vue?vue&type=template&id=0d917aee"
import script from "./StandartReport.vue?vue&type=script&lang=js"
export * from "./StandartReport.vue?vue&type=script&lang=js"
import style0 from "./StandartReport.vue?vue&type=style&index=0&id=0d917aee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports